import LogoBars from "@/components/brand/LogoBars";

/**
 * BtnSpinner — shared loading affordance for canonical CTAs.
 *
 * Now uses the codelumen four-bar mark (LogoBars variant="loading") so every
 * loading moment on the site reinforces the brand's four-layer language,
 * instead of a generic circular ring.
 *
 * Usage:
 *   <button
 *     className="btn-primary-dark"
 *     data-loading={isLoading || undefined}
 *     disabled={isLoading || isDisabled}
 *     aria-busy={isLoading}
 *   >
 *     <span className="btn-label">
 *       Request a Project Evaluation <BtnArrow />
 *     </span>
 *     <BtnSpinner />
 *   </button>
 *
 * The button never resizes: the label fades to 0 and the bars overlay via
 * absolute positioning provided by the .btn-spinner utility in src/index.css.
 */
export function BtnSpinner({
  label = "Loading",
  tone,
}: {
  label?: string;
  /** Force a tone. Defaults to auto: light bars work for dark CTAs, which is
   *  our most common loading surface. */
  tone?: "light" | "dark";
}) {
  return (
    <span className="btn-spinner" aria-hidden="true">
      <LogoBars variant="loading" tone={tone ?? "light"} size="xs" ariaLabel="" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
